import { ROMANIA } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Romania
const ROSection: Section[] = [
  {
    name: '1: Referinţe şi prezentare generală',
    subSections: [
      {
        name: 'Prefaţă',
        page: 3,
      },
      {
        name: 'Scop şi aplicaţii Ghid de teren',
        page: 4,
      },
      {
        name: 'Definiţii cheie',
        page: 5,
      },
      {
        name: 'Ierarhia controalelor',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Vehiculele cu motor – siguranţa rutieră',
        page: 9,
      },
      {
        name: 'Lucrul la înălţime',
        page: 12,
      },
      {
        name: 'Echipamentele electrice mobile (MPE)',
        page: 18,
      },
      {
        name: 'Procedura Lockout/Tagout-separarea electrică',
        page: 22,
      },
      {
        name: 'Lucrările electrice',
        page: 25,
      },
      {
        name: 'Spaţii închise',
        page: 29,
      },
      {
        name: 'Depozitarea materialelor vrac',
        page: 32,
      },
      {
        name: 'Siguranţa vagoanelor de marfă',
        page: 37,
      },
      {
        name: 'Lucrările de excavare şi săpare',
        page: 41,
      },
      {
        name: 'Ridicare şi montaj',
        page: 45,
      },
      {
        name: 'Materiale periculoase',
        page: 49,
      },
      {
        name: 'Lucru la cald',
        page: 52,
      },
    ],
  },
  {
    name: '3: Resurse şi instrumente suplimentare',
    subSections: [
      {
        name: 'Activitatea deasupra şi în jurul apei',
        page: 56,
      },
      {
        name: 'Obiecte căzute sau în cădere',
        page: 59,
      },
      {
        name: 'Testare atmosferică/emisii de gaze',
        page: 61,
      },
      {
        name: 'Comunicare pericol chimic',
        page: 65,
      },
    ],
  },
  {
    name: '4: Practici Cargill de gestionare a siguranţei ',
    subSections: [
      {
        name: 'Terminologie cheie',
        page: 70,
      },
      {
        name: 'Stabilirea evenimentelor care conduc la vătămări corporale grave şi deces (SIF)',
        page: 72,
      },
      {
        name: 'Categorii cu potenţial de vătămări corporale grave şi deces (SIFp)',
        page: 73,
      },
      {
        name: 'Tabel criterii de stabilire automată SIF',
        page: 74,
      },
      {
        name: 'Performanţa umană şi organizaţională (HOP)',
        page: 76,
      },
    ],
  },
];
const ROTableofContent: TableOfContent = {
  language: 'ro',
  sections: ROSection,
  label: 'Cuprins',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (ro_RO)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Ghid de buzunar HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Romanian.pdf',
  source: ROMANIA,
};

export default ROTableofContent;
